































































import Vue from 'vue'
import { ValidationProvider } from 'vee-validate'
import '@/tools/vee-validate'
import dayjs from 'dayjs'
import Dropdown from '@/components/globals/basics/Dropdown.vue'

export default Vue.extend({
  components: {
    ValidationProvider,
    Dropdown,
  },
  props: {
    vid: {
      type: String as () => string,
      default: '',
    },
    rules: {
      type: String as () => string,
      default: '',
    },
    // must be included in props
    value: {
      //@ts-ignore
      type: null as () => any,
      default: '',
    },
  },
  data: () => ({
    birthdayY: '',
    birthdayM: '',
    birthdayD: '',
  }),
  computed: {
    innerValue(): string {
      return [this.birthdayY, this.birthdayM, this.birthdayD].join('-')
    },
    yearList() {
      let results = []
      const currentYear = dayjs().format('YYYY')
      for (let i = 1900; i <= Number(currentYear); i++) {
        results.push(String(i))
      }
      return results
    },
    monthList() {
      let results = []
      for (let i = 1; i <= 12; i++) {
        const value = String('0' + i).slice(-2)
        results.push(value)
      }
      return results
    },
    dayList() {
      const dayNumbers = [...Array(31)].map((_, i) => i + 1)
      return dayNumbers.map((i) => String('0' + i).slice(-2))
    },
  },
  watch: {
    // Handles internal model changes.
    innerValue() {
      this.emitBirthday()
    },
    // Handles external model changes.
    value(newVal) {
      if (!newVal) return
      this.setBirthday(newVal)
    },
  },
  created() {
    if (this.value) {
      this.setBirthday(this.value)
    }
  },
  methods: {
    setBirthday(value: string): void {
      this.birthdayY = value.split('-')[0]
      this.birthdayM = value.split('-')[1]
      this.birthdayD = value.split('-')[2]
      this.emitBirthday()
    },
    emitBirthday(): void {
      this.$emit('input', this.innerValue)
    },
  },
})
